import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { getShadowColor, SHADOW_OFFSET } from './coverHelpers'
import { MediaGroup } from './MediaGroup'

interface Props {
  title: string
  bg: string
  color: string
  titleSize: string
  titleFontWeight: number | string
  cardImage: string | null
  onMediaClick?: () => void
  placeholder?: ReactNode
  className?: string
}

export const Type2Banner = ({
  title,
  bg,
  color,
  titleSize,
  titleFontWeight,
  cardImage,
  onMediaClick,
  placeholder,
  className,
}: Props) => {
  const m = useMessages(messages)
  const shadow = getShadowColor(bg)
  return (
    <div
      className={cn(
        'w-full rounded-xl overflow-hidden border border-border shadow-md flex items-center gap-6 px-8 relative',
        className,
      )}
      style={{ background: bg, aspectRatio: '4 / 1' }}
    >
      <h3
        className="flex-1 leading-[1.1] line-clamp-3 text-left"
        style={{
          fontFamily: '"Wix Madefor Display", system-ui, sans-serif',
          fontWeight: titleFontWeight,
          color,
          fontSize: titleSize,
        }}
      >
        {title || m.untitled}
      </h3>
      <div
        className="h-[78%] aspect-square shrink-0"
        style={{ transform: `translateY(-${(SHADOW_OFFSET * 100) / 2}%)` }}
      >
        <MediaGroup
          size="100%"
          image={cardImage}
          shadow={shadow}
          onMediaClick={onMediaClick}
          placeholder={placeholder}
        />
      </div>
    </div>
  )
}
